const resource = '/insert_point_registrations/'

export const insertPointRegistrationRepository = (axios) => ({
  async create(payload) {
    const response = await axios.post(resource, payload)
    return response.data
  }
})
